import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import PaymentMethodImageCard from './modules/payment-method-image-card'
import AvailablePaymentMethodsModal from './modules/available-payment-methods-modal'
import { getFooterAvailablePaymentMethods } from 'common/utils/utils';
import classNames from 'classnames';


const FooterAvailablePaymentMethods = ({
   defaultCandidatePaymentOptions,
   isMobile,
   wrapperClassName = '',
   primaryColor = '',
   onRemoveModalQuery,
   onAddModalQuery,
   isNextApp,
}) => {
   let avaliablePaymentMethods = useMemo(() => {
      return getFooterAvailablePaymentMethods(defaultCandidatePaymentOptions, isMobile)
   }, [isMobile, defaultCandidatePaymentOptions])

   const wrapperRef = useRef(null)
   const [visibleCount, setVisibleCount] = useState(avaliablePaymentMethods.length);
   const [availablePaymentMethodsModal, setAvailablePaymentMethodsModal] = useState(false)

   const cardWidth = isMobile ? 68 : 88; // single card width (adjust to your design)


   useLayoutEffect(() => {
      const container = wrapperRef.current;
      if(!container) return;

      const gap = 8;        // gap between cards

      const updateVisible = () => {
         const containerWidth = container.offsetWidth;
         if(!containerWidth) return;

         const totalCards = avaliablePaymentMethods.length;
         const cw = cardWidth;
         const g = gap;

         let maxAllFit = Math.floor((containerWidth + g) / (cw + g));
         if(maxAllFit > totalCards) maxAllFit = totalCards;

         if(maxAllFit === totalCards) {
            setVisibleCount(totalCards);
            return;
         }


         let maxWithPlus = Math.floor((containerWidth - cw) / (cw + g));

         if(maxWithPlus < 0) maxWithPlus = 0;
         if(maxWithPlus > totalCards) maxWithPlus = totalCards;

         setVisibleCount(maxWithPlus);
      };

      updateVisible();

      const resizeObserver = new ResizeObserver(updateVisible);
      resizeObserver.observe(container);

      return () => {
         resizeObserver.disconnect();
      }

   }, [avaliablePaymentMethods, cardWidth]);

   useEffect(() => {
      if(onRemoveModalQuery) {
         onRemoveModalQuery()
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   // const visibleMethods = avaliablePaymentMethods
   const visibleMethods = avaliablePaymentMethods.slice(0, visibleCount);
   const hiddenCount = avaliablePaymentMethods.length - visibleCount;

   const CARD_BASE_PROPS = {
      cardWidth: cardWidth,
      wrapperClassName: classNames({
         'h-8': true,
         'md:h-12': !isNextApp,
         'fordesktop:h-12': isNextApp,
      }),
      isNextApp: isNextApp,
   }

   return (
      <>
         <div
            className={ classNames({
               [`w-full max-w-[372px] flex items-center justify-center gap-2 ${ wrapperClassName }`]: true,
               'md:max-w-full': !isNextApp,
               'fordesktop:max-w-full': isNextApp,
            }) }
            ref={ wrapperRef }
         >
            {
               visibleMethods.map(method => (
                  <PaymentMethodImageCard
                     key={ method }
                     { ...CARD_BASE_PROPS }
                     methodType={ method }
                     onClickCard={ () => {
                        // if(method !== 'crypto') return
                        setAvailablePaymentMethodsModal({ isOpen: true, showOptionsType: method })
                     } }
                     primaryColor={ primaryColor }
                     isHideHoverEffect={ isMobile }
                  />
               ))
            }
            {
               hiddenCount > 0 && (
                  <PaymentMethodImageCard
                     { ...CARD_BASE_PROPS }
                     isHiddenCountItem
                     hiddenCount={ hiddenCount }
                     onClickCard={ () => setAvailablePaymentMethodsModal({ isOpen: true }) }
                     isHideHoverEffect={ isMobile }
                  />
               )
            }
         </div>
         {
            Boolean(availablePaymentMethodsModal?.isOpen) && (
               <AvailablePaymentMethodsModal
                  avaliablePaymentMethods={ avaliablePaymentMethods }
                  isMobile={ isMobile }
                  onCloseModal={ () => setAvailablePaymentMethodsModal({}) }
                  defaultCandidatePaymentOptions={ defaultCandidatePaymentOptions }
                  primaryColor={ primaryColor }
                  showOptionsType={ availablePaymentMethodsModal.showOptionsType }
                  onRemoveModalQuery={ onRemoveModalQuery }
                  onAddModalQuery={ onAddModalQuery }
                  isNextApp={ isNextApp }
               />
            )
         }
      </>
   )
}

FooterAvailablePaymentMethods.propTypes = {
   isMobile: PropTypes.bool,
   wrapperClassName: PropTypes.string,
   defaultCandidatePaymentOptions: PropTypes.object,
   primaryColor: PropTypes.string,
   onRemoveModalQuery: PropTypes.func,
   onAddModalQuery: PropTypes.func,
   isNextApp: PropTypes.bool,
}

export default FooterAvailablePaymentMethods;
